// removed by extract-text-webpack-plugin
module.exports = {"event-inner":"event-card__event-inner__279Ts","event-flyer":"event-card__event-flyer__1sLIE","event-information":"event-card__event-information__3_rXQ","avatar-wrapper":"event-card__avatar-wrapper__3odoC","event-name":"event-card__event-name__2IoYt","event-operate-wrapper":"event-card__event-operate-wrapper__XJVFC","event-host":"event-card__event-host__2iqvz","host-name":"event-card__host-name__3CBau","operate-button":"event-card__operate-button__1EB0P","operate-list":"event-card__operate-list__1uQvZ","delete-text":"event-card__delete-text__2dzyj"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/event/EventList/EventCard/event-card.scss
// module id = 1738
// module chunks = 1